import React from 'react';
import { Shield, X, Menu } from 'lucide-react';

interface SidebarLogoProps {
    sidebarOpen: boolean;
    setSidebarOpen: (open: boolean) => void;
}

export const SidebarLogo: React.FC<SidebarLogoProps> = ({ sidebarOpen, setSidebarOpen }) => {
    return (
        <div className="h-20 flex items-center justify-between px-4 border-b border-[var(--border-color)]">
            {sidebarOpen ? (
                <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg">
                        <Shield className="h-7 w-7 text-white" />
                    </div>
                    <div>
                        <h1 className="text-lg font-bold text-blue-600 leading-tight">
                            Magnus Resolve
                        </h1>
                        <p className="text-xs text-gray-500 font-medium">
                            Failure Analysis
                        </p>
                    </div>
                </div>
            ) : (
                <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center shadow-lg mx-auto">
                    <Shield className="h-6 w-6 text-white" />
                </div>
            )}
            {sidebarOpen && (
                <button
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                    className="p-2 rounded-lg hover:bg-[var(--bg-tertiary)] text-[var(--text-secondary)]"
                >
                    <X size={20} />
                </button>
            )}
            {!sidebarOpen && (
                <button
                    onClick={() => setSidebarOpen(!sidebarOpen)}
                    className="absolute top-24 left-1/2 -translate-x-1/2 p-1.5 rounded-lg hover:bg-[var(--bg-tertiary)] text-[var(--text-secondary)]"
                >
                    <Menu size={18} />
                </button>
            )}
        </div>
    );
};
